import { lazy } from 'react';

import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';

const EnterEINNumber = lazy(() => import('./components/EnterEINNumber'));

export default function EnterEINNumberModal({ handleClose }) {
  return (
    <FormModal
      handleBack={handleClose}
      handleClose={handleClose}
    >
      <EnterEINNumber handleClose={handleClose} />
    </FormModal>
  );
}

EnterEINNumberModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
